<pms-payment [(state)]="state" [paymentGroupId]="paymentId" (closePayment)="removeTab(true)"></pms-payment>
